import React, { useEffect, useState } from "react";
import { Result, Drugs } from "../../interface/Drugs";
import { DrugsAxiosInstance } from "../../Network/DrugsAxiosInstance";
import { AxiosResponse,AxiosError } from "axios";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const DrugsGrouping: React.FC = () => {
  const [items, setItems] = useState<Drugs>({ result: [] });

  const [Name, setName] = useState<string>("");

  const [listOfDrugGroups, setlistOfDrugGroups] = useState<string[]>([]);
  const [listOfCustomDrugGroups, setlistOfCustomDrugGroups] = useState<
    string[]
  >([]);
  const [listOfDrugs, setlistOfDrugs] = useState<string[]>([]);
  const token = localStorage.getItem('token') || "";
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    fetchItems();
  }, []);
  const validateForm = (): boolean => {
    if (!Name.trim()) {
      setErrorMessage("Name is required.");
      return false;
    }
    setErrorMessage("");
    return true;
  };


  //............................................. get data ...............................................
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await DrugsAxiosInstance.get("getdrug", {
          headers: {
             Authorization: `Bearer ${token}`, // Send token with request
           } 
         });
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const addItem = async (): Promise<void> => {
    try {
      const newDrugsGroup = {
        name: Name,
        list_of_drug_groups: listOfDrugGroups,
        list_of_custom_drug_groups: listOfCustomDrugGroups,
        list_of_drugs: listOfDrugs,
        token: token,
      };
      
      const response = await DrugsAxiosInstance.post("add", newDrugsGroup, {
        headers: {
           Authorization: `Bearer ${token}`, // Send token with request
         } 
       });
      
      if (response.data.success) {
        fetchItems();
        setName("");
        setlistOfDrugGroups([]);
        setlistOfCustomDrugGroups([]);
        setlistOfDrugs([]);
        console.log("New group added successfully:", newDrugsGroup);
      }
    } catch (error) {
      console.error("Error adding item:", error);
  
      if (error instanceof AxiosError && error.response) {
        const errorMessage = error.response.data.error;
        if (errorMessage === 'Name Drug already exists. Please choose a different Name Drug.') {
          toast.error(errorMessage);
        } else {
          toast.error("Name Drug already exists. Please choose a different Name Drug.");
        }
      } else {
        toast.error("An unexpected error occurred.");
      }
    }
  };
  
  //.............................................end add data ...............................................
  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    try {
      const updatedItem = {
        name: Name,
        list_of_drug_groups: listOfDrugGroups,
        list_of_custom_drug_groups: listOfCustomDrugGroups,
        list_of_drugs: listOfDrugs,
        id: id,
        token: token,
      };

      const response = await DrugsAxiosInstance.put(`update`, updatedItem, {
        headers: {
           Authorization: `Bearer ${token}`, // Send token with request
         } 
       });
      if (response.data.success) {
      fetchItems();
      setName("");
      setlistOfDrugGroups([]);
      setlistOfCustomDrugGroups([]);
      setlistOfDrugs([]);
      setEditIndex(null);

      console.log("New group updated successfully:", updatedItem);
      }
    } catch (error) {
      console.error("Error updating item:", error);
      if (error instanceof AxiosError && error.response) {
        const errorMessage = error.response.data.error;
        if (errorMessage === 'Name Drug already exists. Please choose a different Name Drug.') {
          toast.error(errorMessage);
        } else {
          toast.error("Name Drug already exists. Please choose a different Name Drug.");
        }
      } else {
        toast.error("An unexpected error occurred.");
      }
    }
  };

  //.............................................end update data ...............................................
  // ............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await DrugsAxiosInstance.delete(`delete/${id}`, {
        headers: {
           Authorization: `Bearer ${token}`, // Send token with request
         },
         data: { token: token }, 
       });
      console.log(id);
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  // .............................................end remove data ...............................................



  const resetForm = () => {
    setName("");
    setlistOfDrugGroups([]);
    setlistOfCustomDrugGroups([]);
    setlistOfDrugs([]);
    setEditIndex(null);

  };

  const handleEdit =  (item: Result) => {
    setName(item.name);
    setlistOfDrugGroups(item.list_of_drug_groups);
    setlistOfCustomDrugGroups(item.list_of_custom_drug_groups);
    setlistOfDrugs(item.list_of_drugs);
    setEditIndex(item.id);
  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "list_of_drug_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ListOfDrugGroups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const druggroups = row.getValue("list_of_drug_groups") as string[];
        return Array.isArray(druggroups) ? druggroups.join(", ") : druggroups;
      },
    },
 {
      accessorKey: "list_of_custom_drug_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >ListOfCustomDrugsGroups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const CustomDrugs = row.getValue("list_of_custom_drug_groups") as string[];
        return Array.isArray(CustomDrugs) ? CustomDrugs.join(", ") : CustomDrugs;
      },
    }, {
      accessorKey: "list_of_drugs",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ListOfDrugs
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const drugs = row.getValue("list_of_drugs") as string[];
        return Array.isArray(drugs) ? drugs.join(", ") : drugs;
      },
    },
  ];
  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Drugs Grouping Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
    
      {/* model */}

      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetForm}
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2"> Name</label>
              <input
                type="text"
                className="form-control "
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={Name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) {
                    setErrorMessage(""); 
                  }
                }}
              />
            
    
              {Name.trim() === "" && (
                <div style={{ color: "red" }}>
                   Name is required.
                </div>
              )}
              
        </div>
        <div style={{ marginBottom: "10px" }}>
              <label className="m-2">List Of Drug Groups</label>

              <input
                type="text"
                className="form-control "
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={listOfDrugGroups.join(",")}
                onChange={(e) => setlistOfDrugGroups([e.target.value])}
              />
              </div>
              <div style={{ marginBottom: "10px" }}>
              <label className="m-2">List Of Custom Drugs Groups</label>

              <input
                type="text"
                className="form-control "
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={listOfCustomDrugGroups.join(",")}
                onChange={(e) => setlistOfCustomDrugGroups([e.target.value])}
              />
              </div>
              <div style={{ marginBottom: "10px" }}>
              <label className="m-2">List Of Drugs</label>
              <input
                type="text"
                className="form-control "
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={listOfDrugs.join(",")}
                onChange={(e) => setlistOfDrugs([e.target.value])}
              />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }
                disabled={!Name.trim()}
              >
                {editIndex === null ? "Add Item" : "Update Item"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={resetForm}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* table */}
  
<DataTable
  columns={columns}
  data={items.result}
  searchColumn="name"
  addButtonLabel="Add New Drugs Grouping" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
       <ToastContainer
   
   position="top-center"
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   closeOnClick
   rtl={false}
   pauseOnFocusLoss
   draggable
   pauseOnHover
 />
    </div>
  );
};
export default DrugsGrouping;
